/** @see net/disy/cadenza/workbook/model/AttributeBundleName.java */
export type AttributeBundleName =
  | CHART_BUNDLE_NAMES
  | TABLE_BUNDLE_NAMES
  | MAP_BUNDLE_NAMES
  | typeof INDICATOR_BUNDLE_NAME
  | typeof UNUSED_BUNDLE_NAME
  | typeof SPATIAL_FILTER_BUNDLE_NAME
  | typeof REPORT_BUNDLE_NAME
  | typeof TEXT_WITH_DATA_BUNDLE_NAME;

/** @deprecated Use the type instead */
export const CHART_BUNDLE_NAMES: Readonly<Record<CHART_BUNDLE_NAMES, AttributeBundleName>> = {
  MEASURE: 'MEASURE',
  DIMENSION: 'DIMENSION',
};

export type CHART_BUNDLE_NAMES = 'MEASURE' | 'DIMENSION';

/** @deprecated Use the type instead */
export const TABLE_BUNDLE_NAMES: Readonly<Record<TABLE_BUNDLE_NAMES, AttributeBundleName>> = {
  ROWS: 'ROWS',
  COLUMNS: 'COLUMNS',
  MEASURES: 'MEASURES',
  INDIVIDUAL_COLUMNS: 'INDIVIDUAL_COLUMNS',
};

export type TABLE_BUNDLE_NAMES = 'ROWS' | 'COLUMNS' | 'MEASURES' | 'INDIVIDUAL_COLUMNS';

/** @deprecated Use the type instead */
export const MAP_BUNDLE_NAMES: Readonly<Record<MAP_BUNDLE_NAMES, AttributeBundleName>> = {
  ANY: 'ANY',
  GEOMETRY: 'GEOMETRY',
  COLOR_CLASSIFICATION: 'COLOR_CLASSIFICATION',
  SYMBOL_SIZE: 'SYMBOL_SIZE',
  IMAGE: 'IMAGE',
  LABEL: 'LABEL',
  HEATMAP_WEIGHTING: 'HEATMAP_WEIGHTING',
  PIE_CHART_MEASURE: 'PIE_CHART_MEASURE',
  PIE_CHART_DIMENSION: 'PIE_CHART_DIMENSION',
  SORTING: 'SORTING',
  MAP_TIP: 'MAP_TIP',
  CIRCLE_SECTORS_RADIUS: 'CIRCLE_SECTORS_RADIUS',
  CIRCLE_SECTORS_DIRECTION: 'CIRCLE_SECTORS_DIRECTION',
  CIRCLE_SECTORS_CENTRAL_ANGLE: 'CIRCLE_SECTORS_CENTRAL_ANGLE',
};

export type MAP_BUNDLE_NAMES =
  | 'ANY'
  | 'GEOMETRY'
  | 'COLOR_CLASSIFICATION'
  | 'SYMBOL_SIZE'
  | 'IMAGE'
  | 'LABEL'
  | 'HEATMAP_WEIGHTING'
  | 'PIE_CHART_MEASURE'
  | 'PIE_CHART_DIMENSION'
  | 'SORTING'
  | 'MAP_TIP'
  | 'CIRCLE_SECTORS_RADIUS'
  | 'CIRCLE_SECTORS_DIRECTION'
  | 'CIRCLE_SECTORS_CENTRAL_ANGLE';

export const INDICATOR_BUNDLE_NAME = 'MEASURE';
export const UNUSED_BUNDLE_NAME = 'UNUSED';
export const SPATIAL_FILTER_BUNDLE_NAME = 'SPATIAL_FILTER';
export const REPORT_BUNDLE_NAME = 'REFERENCE_ATTRIBUTE';
export const TEXT_WITH_DATA_BUNDLE_NAME = 'ATTRIBUTES';
